import React from 'react'
import { Box } from '@mui/joy'
import JSONPretty from 'react-json-pretty'
import { Tag } from '../Snippet'
import { useTranslation } from 'react-i18next'

const CellAudienceSegmentationRules = ({ type, value }) => {
    const { t } = useTranslation();
    return (
        <Box className={"list-element-cell cell-" + type}>
            {
                value.map((v, k) => {
                    return (
                        <Tag key={k}><strong>{t(v.field)}</strong> <em>{t(v.operator).toLowerCase()}</em>  <strong>{v.value}</strong></Tag>
                    )
                })
            }
        </Box>
    )
}

export default CellAudienceSegmentationRules